import { EVENT_FORMAT } from "@/utils/constants";

export function isParticipantFormatPhysical(participant) {
  return participant?.keyMomentFormats?.includes(EVENT_FORMAT.PHYSICAL);
}